import Vue from 'vue';
import Vuex from 'vuex';
import IDataTable from '../models/IDataTable';
import DataAcessApi from '../api/DataAccessApi';
import { StringObjectTuple } from '@/store/types/types';
import { StringObjectArrayListTuple } from '../types/types';

Vue.use(Vuex);

export const createDataAccessStore = (storeId: string) => ({
    namespaced: true, // Habilita namespaces
    state: {
        FormId: '', // Estado inicial de FormId
        results: null as IDataTable | null // Estado inicial para resultados
    },
    mutations: {
        // Actualiza los resultados
        setResults(state: any, results: IDataTable | null) {
            state.results = results;
        },
        // Actualiza el FormId
        setFormId(state: any, formId: string) {
            state.FormId = formId;
        }
    },
    actions: {
        // Acción para ejecutar el procedimiento estructurado
        async ExecStructuredProcedure(
            { commit, state }: any,
            payload: { spName: string; parameters: StringObjectTuple[]; structures: StringObjectArrayListTuple[] }
        ) {
            const api = new DataAcessApi(state.FormId);
            try {
                const data = await api.ExecStructuredProcedure(payload.spName, payload.parameters, payload.structures);
                commit('setResults', data);
            } catch (error) {
                console.error('Error fetching fields:', error);
            }
        }
    }
});

// Crear una instancia principal de Vuex Store
const storeDataAccess = new Vuex.Store({});

// Función para registrar dinámicamente el módulo
export const registerModule = (storeId: string) => {
    if (!storeDataAccess.hasModule(storeId)) {
        storeDataAccess.registerModule(storeId, createDataAccessStore(storeId));
    }
};

export default storeDataAccess;
